/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_Deck_Phase_ClosedInputs */



/**
* | output |
* | --- |
* | "Closed" |
*
* @param {Tournaments_Lib_Deck_Phase_ClosedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_deck_phase_closed = /** @type {((inputs?: Tournaments_Lib_Deck_Phase_ClosedInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_Deck_Phase_ClosedInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geschlossen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermé")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("已关闭")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("已截止")
	if (locale === "ko") return /** @type {LocalizedString} */ ("마감")
	return /** @type {LocalizedString} */ ("Closed")
});